import ClientLayerBlueprint from "components/blueprints/ClientLayerBlueprint";
import React from "react";

function ClientAnalyticsPage() {
  return <div>ClientAnalyticsPage</div>;
}

export default ClientLayerBlueprint(ClientAnalyticsPage);
